export enum EPriceType {
  STATIC = 'static',
  VARIABLE = 'variable',
  MULTIPLE = 'multiple',
}

export const priceTimeLabelOptions = [
  { label: '9 am', value: '09:00:00' },
  { label: '10 am', value: '10:00:00' },
  { label: '11 am', value: '11:00:00' },
  { label: '12 pm (noon)', value: '12:00:00' },
  { label: '1 pm', value: '13:00:00' },
  { label: '2 pm', value: '14:00:00' },
  { label: '3 pm', value: '15:00:00' },
  { label: '4 pm', value: '16:00:00' },
  { label: '5 pm', value: '17:00:00' },
  { label: '6 pm', value: '18:00:00' },
];
